import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { LoginService } from '../login/login.service';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})

export class RoleGuard implements CanActivate {
  constructor(public authService: LoginService,
    public router: Router) {
  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      return true;
    if (this.authService.isAuthenticated() === false) {
      this.router.navigate(['/pages/login']);
      return false;
    }
    const role = next.data['role'] as string[];
    if (this.authService.hasRoleAndPermission(role)) {
      return true;
    }
     Swal.fire('Acceso denegado', 'No tienes acceso a este recurso', 'warning');
    return false;
  }
}
